<app-matrix-card
  [title]="'cards.midasAiVideos' | translate"
  [periodLabel]="data()?.periodLabel || ('midasAiVideos.last30Days' | translate)"
  iconUrl="/icons/play_ai.png"
  link="/midas-ai-videos"
  [tightContentSpacing]="true"
  [highlighted]="highlighted"
  [aria-label]="'cards.midasAiVideos' | translate"
>
  @if (loading()) {
    <div class="relative min-h-[253px]">
      <app-loading [showLogo]="false" [textValue]="'cards.loading'"></app-loading>
    </div>
  } @else if (data(); as d) {
    @if (d.flagged === 0 && d.notFlagged === 0) {
      <div class="flex items-center justify-center min-h-[253px] text-sm text-slate-200/70">
        {{ 'midasAiVideos.noVideosToShow' | translate }}
      </div>
    } @else {
      <div class="flex items-center justify-center gap-[39px]">
        <!-- Chart on the left -->
        <div class="shrink-0 size-[253px] drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]">
          <app-generic-chart [config]="d.chartConfig" [loading]="loading()" [minHeightPx]="253" />
        </div>

        <!-- Legend on the right -->
        <div class="flex flex-col gap-[30px] items-start justify-end">
          <div class="flex flex-col gap-[16px] items-start justify-center">
            <div class="flex gap-[8px] items-center">
              <div class="shrink-0 size-[18px]">
                <div class="size-full rounded-full bg-[#39a8de]"></div>
              </div>
              <p class="text-[18px] font-normal leading-[22px] text-white">
                {{ 'midasAiVideos.flagged' | translate }}
              </p>
            </div>
            <div class="flex gap-[8px] items-center">
              <div class="shrink-0 size-[18px]">
                <div class="size-full rounded-full bg-[#f59e0b]"></div>
              </div>
              <p class="text-[18px] font-normal leading-[22px] text-white">
                {{ 'midasAiVideos.notFlagged' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    }
  } @else {
    <div class="flex items-center justify-center min-h-[253px] text-sm text-slate-200/70">
      {{ 'midasAiVideos.unableToLoad' | translate }}
    </div>
  }
</app-matrix-card>


